import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import services from '../../services';
import { toast } from 'react-toastify';
import { GET_ALL_USER } from '../../utils/Apifunction';
// import Select from 'react-dropdown-select';
import Select, { components } from 'react-select';

const Automation = ({
    onHide,
    show,
    boardName,
    gmailUsers,
    editData,
    editId,
    getAllAutomation,
    setStep,
    setAutomations,
    setEditId,
}) => {
    const [boardSelect, setBoardSelect] = useState('');
    const [boardColumnSelect, setBoardColumnSelect] = useState('');
    const [selectGmailUser, setSelectGmailUser] = useState('');
    const [rule, setRule] = useState('');
    const [userSelect, setUserSelect] = useState('');
    const [activeTab, setActiveTab] = useState('Gmail');
    const [allClient, setAllClient] = useState([]);
    const [editDatas, setEditDatas] = useState(null);
    const [userData, setUserData] = useState([]);
    const [selectedBoardColumn, setSelectedBoardColumn] = useState([]);
    const [automationsData, setAutomationsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [duplicateMsg, setDuplicateMsg] = useState('');
    const [selectedType, setSelectedType] = useState();
    const conditionOptions = [
        { label: 'the subject', value: 'subject' },
        { label: 'the From email address', value: 'sender' },
        { label: 'the To email address', value: 'recipient' },
    ];
    const operatorOptions = [
        { label: 'contains', value: 'contains' },
        { label: 'does not contain', value: 'doesNotContain' },
        { label: 'is', value: 'equals' },
    ];
    const completedConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'sender' },
        { label: "the customer's email address", value: 'recipient' },
        { label: 'assignee', value: 'assignee' },
    ];
    const ConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'recipient' },
        // { label: "the customer's email address", value: 'recipient' },
        { label: 'assignee', value: 'assignee' },
    ];
    const [actionRows, setActionRows] = useState([{ action: '', order: '', boardId: '', entityId: '' }]);

    const initialActionRow = { action: '', order: '', boardId: '', entityId: '', user: '' };

    const initialCondition = {
        field: conditionOptions[0]?.value || '',
        operator: operatorOptions[0]?.value || '',
        value: '',
    };

    const sla_alert_action = [
        {
            label: '🔥 SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 bg-pink-100',
        },
        {
            label: '⚡ SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 bg-orange-100',
        },
    ];

    const MultiValue = (props) => {
        const className = props.data.className || '';
        return (
            <div className={`flex items-center rounded-md px-2 py-1 mr-1 mb-1 text-sm ${className}`}>
                <span className="mr-1">{props.data.label}</span>
                <components.MultiValueRemove {...props}>
                    <span {...props.removeProps} className="ml-1 text-red-500 hover:text-red-700 cursor-pointer">
                        ×
                    </span>
                    {/* ❌ This will now appear and work */}
                </components.MultiValueRemove>
            </div>
        );
    };

    const Option = (props) => {
        const { className = '', label } = props.data;
        return (
            <components.Option {...props}>
                <div className={`text-sm rounded-md px-2 py-1 w-[120px] ${className}`}>{label}</div>
            </components.Option>
        );
    };

    const customStyles = {
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.color || '#f3f4f6',
            borderRadius: '6px',
            padding: '2px 4px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            fontSize: '0.875rem',
            color: '#111827',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#ef4444',
            ':hover': {
                backgroundColor: '#fecaca',
                color: '#b91c1c',
            },
        }),
    };

    const formattedOptions = sla_alert_action.map((item) => ({
        label: `# ${item.label}`,
        value: item.value,
        className: item.color || '',
    }));

    // For "mail" condition structure
    const defaultMailConditions = [{ field: 'title', operator: 'equals', value: '' }];

    const defaultNoReplyToCustomerConditions = [{ field: 'customerWaiting', operator: 'moreThanMins', value: '' }];
    const defaultNoReplyFromCustomerConditions = [
        { field: 'customerNotResponding', operator: 'moreThanMins', value: '' },
    ];
    const [conditions, setConditions] = useState([initialCondition]);
    const [syncGmail, setSyncGmail] = useState([]);
    const [selectedMailUser, setSelectedMailUser] = useState();
    const [showAction, setShowAction] = useState();
    const [actions, setActions] = useState(false);
    const [skipInbox, setSkipInbox] = useState(false);
    const [skipReplies, setSkipReplies] = useState(true);
    const [runOnExisting, setRunOnExisting] = useState(false);
    const [existingDays, setExistingDays] = useState('1');

    useEffect(() => {
        if (show && !editId) {
            setBoardSelect('');
            setBoardColumnSelect('');
            setSelectGmailUser('');
            setRule('');
            setUserSelect('');
            setEditDatas(null);
            // Clean up localStorage
            localStorage.removeItem('editGmailUserId');
        }
    }, [show, editId]);

    useEffect(() => {
        if (editDatas && selectedBoardColumn && selectedBoardColumn.length > 0 && editDatas?.condition?.boardListId) {
            setBoardColumnSelect(editDatas?.condition?.boardListId);
        }
    }, [selectedBoardColumn, editDatas]);

    useEffect(() => {
        if (boardSelect) {
            getSELECTED_BOARD(boardSelect);
        }
    }, [boardSelect]);

    const getAllAutomationData = async () => {
        setLoading(true);
        try {
            const response = await services.automations.GET_ALL_AUTOMATIONS();

            if (response) {
                setAutomationsData(response);
            }
        } catch (e) {
            toast.error('Failed to fetch automations');
        }
        setLoading(false);
    };

    useEffect(() => {
        getAllAutomationData();
    }, []);

    const getSELECTED_BOARD = async (boardSelect) => {
        try {
            const { data } = await services.board.SELECTED_BOARD(boardSelect);
            setSelectedBoardColumn(data);
            setBoardColumnSelect('');
        } catch {
            console.error(e);
        }
    };
    const handleCreate = async () => {
        const payload = buildPayload();

        try {
            const response = !editId
                ? await services.automations.CREATE_AUTOMATIONS(payload)
                : await services.automations.UPDATE_AUTOMATIONS(editId, payload);
            if (response) {
                toast.success(editId ? 'Automations Updated Successfully' : 'Automations Added Successfully');
                setStep(1);
                getAllAutomation && getAllAutomation();

                localStorage.removeItem('editGmailUserId');
            }
        } catch (e) {
            console.error(e);
        }
    };

    const addCondition = () => {
        const validConditions = Array.isArray(conditions) ? conditions : [];

        let availableOptions = [];

        if (selectedType === 'new') {
            availableOptions = conditionOptions;
        } else if (selectedType === 'itemAdded') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyToCustomer') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyFromCustomer') {
            availableOptions = completedConditionOptions;
        }

        if (availableOptions.length === 0) return;

        const defaultField = availableOptions[0]?.value || '';
        let defaultOperator = operatorOptions[0]?.value || '';

        // Set appropriate default operator based on field type
        if (defaultField === 'assignee') {
            defaultOperator = 'equals';
        } else if (defaultField === 'customerWaiting' || defaultField === 'customerNotResponding') {
            defaultOperator = 'moreThanMins';
        }

        setConditions((prev) =>
            Array.isArray(prev)
                ? [
                    ...prev,
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ]
                : [
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ],
        );
    };

    const removeCondition = (index) => {
        const updated = conditions.filter((_, i) => i !== index);
        setConditions(updated);
    };

    const conditionThenOption = [
        // { label: 'move it to the next list', value: 'moveToNext' },
        // { label: 'move it to the previous list', value: 'moveToPreviousList' },
        { label: 'move it to the specific list', value: 'createOnList' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'assign it to', value: 'assignTo' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
    ];

    const getEditData = async (editId) => {
        try {
            const response = await services.automations.GET_BY_ID_AUTOMATIONS(editId);
            if (response && response.data && response.data.data) {
                const automation = response.data.data;
                setConditions([]);

                setSelectedType(automation?.type);
                setRule(automation?.name);
                const emailResponse = await services.email.Get_The_Linked_Email();
                const formattedOptions =
                    emailResponse?.data?.map((item) => ({
                        value: item.id,
                        label: item.email,
                    })) || [];

                setSyncGmail(formattedOptions);

                if (automation?.type === 'new' && automation?.when?.gmailUserId) {
                    const matchedUser = formattedOptions.find((user) => user.value === automation.when.gmailUserId);
                    if (matchedUser) {
                        setSelectedMailUser(matchedUser); // this sets value for <Select>
                    }
                }

                const userConditions = automation.condition.filter(
                    (cond) =>
                        !(
                            cond.operand === 'board' &&
                            (automation?.type === 'itemAdded' ||
                                automation?.type === 'noReplyToCustomer' ||
                                automation?.type === 'noReplyFromCustomer')
                        ),
                );

                setConditions(
                    userConditions.map((cond) => ({
                        field: cond.operand,
                        operator: cond.operator,
                        value:
                            cond.operand === 'assignee' && Array.isArray(cond.value)
                                ? cond.value[0]?.entityId || ''
                                : cond.value,
                    })),
                );

                let boardId = null;
                if (automation?.type === 'new') {
                    const createOnListAction = automation.action.find((a) => a.action === 'createOnList');
                    if (createOnListAction) {
                        boardId = createOnListAction.boardId;
                    }
                } else {
                    const boardCondition = automation.condition.find((cond) => cond.operand === 'board');
                    if (boardCondition) {
                        boardId = boardCondition.value;
                    }
                }

                if (boardId) {
                    setBoardSelect(boardId);
                    // Get board columns for this board
                    getSELECTED_BOARD(boardId);
                }

                // Set actions
                const mainActions = automation.action
                    .filter((a) => a.action !== 'subEmailInbox' && a.action !== 'emailInbox')
                    .map((action) => {
                        // Map the action data to match the form structure
                        const mappedAction = {
                            action: action.action,
                            order: action.order,
                        };

                        // Handle different action types
                        if (action.action === 'createOnList') {
                            mappedAction.boardId = action.boardId;
                            mappedAction.entityId = action.entityId;
                        } else if (['assignTo', 'unassign'].includes(action.action)) {
                            mappedAction.user = action.entityId;
                        } else if (action.action === 'assignToRoundRobin') {
                            mappedAction.users =
                                action.entityIds?.map((e) => ({
                                    value: e.entityId,
                                    label: e.name,
                                })) || [];
                        } else if (action.action === 'setSlaAlertTag') {
                            mappedAction.entityId = action.entityValue;
                        } else if (
                            ['sendOverdueAlert', 'sendUpcomingAlert', 'sendNotificationTo'].includes(action.action)
                        ) {
                            mappedAction.entityId = action.entityId;
                            mappedAction.message = action.entityValue;
                        } else if (action.action === 'moveToNextList') {
                            // Map moveToNextList to moveToNext for the form
                            mappedAction.action = 'moveToNext';
                        } else if (action.action === 'moveToPreviousList') {
                            // Map moveToPreviousList to moveToPreviousList for the form
                            mappedAction.action = 'moveToPreviousList';
                        } else if (action.action === 'markComplete') {
                            mappedAction.action = 'markComplete';
                        } else if (action.action === 'markIncomplete') {
                            mappedAction.action = 'markIncomplete';
                        }

                        return mappedAction;
                    });
                setActionRows(mainActions);
                if (automation?.type === 'new') {
                    const subEmailInboxAction = automation.action.find((a) => a.action === 'subEmailInbox');
                    const emailInboxAction = automation.action.find((a) => a.action === 'emailInbox');
                    setSkipReplies(subEmailInboxAction ? subEmailInboxAction.isProcessed : false);
                    setSkipInbox(emailInboxAction ? emailInboxAction.hasReply : false);
                }
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (editId) {
            getEditData(editId);
        }
    }, [editId]);

    useEffect(() => {
        if (editId && syncGmail.length > 0 && selectedType === 'new') {
            // Set Gmail user from stored gmailUserId
            const storedGmailUserId = localStorage.getItem('editGmailUserId');
            if (storedGmailUserId) {
                const gmailUser = syncGmail.find((user) => user.value === storedGmailUserId);
                if (gmailUser) {
                    setSelectedMailUser(gmailUser);
                }
            }
        }
    }, [syncGmail, editId, selectedType]);

    // useEffect(() => {
    //     if (editData) {
    //         setSelectedType(editData.type);
    //         setName(editData.name);
    //         setConditions(
    //             editData.condition.map(cond => ({
    //                 field: cond.operand,
    //                 operator: cond.operator,
    //                 value: cond.value,
    //             }))
    //         );
    //         const mainActions = editData.action.filter(
    //             a => a.action !== 'subEmailInbox' && a.action !== 'emailInbox'
    //         );
    //         setActionRows(mainActions);

    //         const subEmailInboxAction = editData.action.find(a => a.action === 'subEmailInbox');
    //         const emailInboxAction = editData.action.find(a => a.action === 'emailInbox');
    //         setSkipReplies(subEmailInboxAction ? subEmailInboxAction.isProcessed : false);
    //         setSkipInbox(emailInboxAction ? emailInboxAction.hasReply : false);
    //     }
    // }, [editData]);

    useEffect(() => {
        GET_ALL_USER_DATA();
        GET_ALL_Whastpp_DATA();
    }, []);

    const GET_ALL_USER_DATA = async () => {
        const response = await GET_ALL_USER();
        response && setUserData(response?.users);
    };

    const handleSelect = (key) => {
        setActiveTab(key);
        setSelectGmailUser('');
    };

    const GET_ALL_Whastpp_DATA = async () => {
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        }
    };

    const checkDuplicate = (boardId, gmailUserId) => {
        if (!Array.isArray(automationsData) || !boardId) return false;


        // For new type, check both board and gmail user
        if (selectedType === 'new' && gmailUserId) {
            return automationsData.some(
                (auto) =>
                    auto?.type === selectedType &&
                    auto?.action?.some((action) => action.boardId === boardId) &&
                    auto?.when?.gmailUserId === gmailUserId &&
                    (editId ? auto.id !== editId : true),
            );
        }

        // For other automation types, check board usage in different ways
        return automationsData.some((auto) => {
            if (auto?.type !== selectedType || (editId && auto.id === editId)) {
                return false;
            }

            // Check if board is used in conditions
            const boardInConditions = auto?.condition?.some(
                (cond) => cond.operand === 'board' && cond.value === boardId,
            );

            // Check if board is used in actions
            const boardInActions = auto?.action?.some((action) => action.boardId === boardId);

            // Check if board is used in when clause
            const boardInWhen = auto?.when?.boardId === boardId;

            return boardInConditions || boardInActions || boardInWhen;
        });
    };

    const handleGmailUserChange = (value) => {
        setSelectGmailUser(value);
        // Check for duplicates when gmail user changes
        if (boardSelect && selectedType) {
            const duplicate = checkDuplicate(boardSelect, value);
            setIsDuplicate(duplicate);
            if (duplicate) {
                if (selectedType === 'new') {
                    setDuplicateMsg('Automation already exists for this board ');
                } else {
                    setDuplicateMsg(`Automation of type "${selectedType}" already exists for this board.`);
                }
            } else {
                setDuplicateMsg('');
            }
        }
    };

    const handleBoardChange = (value) => {
        setBoardSelect(value);

        // Immediately check for duplicates when board is selected
        if (value && selectedType) {
            const duplicate = checkDuplicate(value, selectGmailUser);
            setIsDuplicate(duplicate);

            if (duplicate) {
                if (selectedType === 'new') {
                    setDuplicateMsg('Automation already exists for this board ');
                } else {
                    setDuplicateMsg(`Automation of type "${selectedType}" already exists for this board.`);
                }
            } else {
                setDuplicateMsg('');
            }
        } else {
            setIsDuplicate(false);
            setDuplicateMsg('');
        }
    };

    // Prepare options
    const options = userData?.map((user) => ({
        value: user.id,
        label: user.name,
        email: user.email,
    }));
    const availableActions = [
        { label: 'assign it to', value: 'assignTo' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
    ];

    const addActionRow = () => {
        setActionRows([...actionRows, { action: '', user: '', boardId: '', entityId: '' }]);
    };

    const updateAction = (index, value) => {
        const updated = [...actionRows];

        if (selectedType === 'new' && index === 0) {
            const selectedBoard = boardName.find((b) => b.value === value);

            updated[index].action = 'createOnList';
            updated[index].boardId = value;
            updated[index].entityId = '';
            updated[index].user = '';

            setShowAction(value);
        } else {
            if (boardName.some((b) => b.value === value)) {
                updated[index].boardId = value;
            } else {
                updated[index].action = value;
                updated[index].user = '';
                updated[index].boardId = '';
                updated[index].entityId = '';

                // Set default messages for specific action types
                if (value === 'sendOverdueAlert') {
                    updated[index].message = '🔥Overdue - Customer is waiting for a reply.';
                } else if (value === 'sendUpcomingAlert') {
                    updated[index].message = "⚡Upcoming soon - Don't forget";
                } else if (value === 'sendNotificationTo') {
                    updated[index].message = 'Issue escalated to you';
                }
            }
        }

        setActionRows(updated);
    };

    const updateUser = (index, value, isMulti = false) => {
        const updated = [...actionRows];
        if (isMulti) {
            updated[index].users = value;
            delete updated[index].user;
        } else {
            updated[index].user = value;
            delete updated[index].users;
        }
        setActionRows(updated);
    };

    const showUserSelectFor = ['assignTo', 'assignToRoundRobin'];
    const shouldHideAddButton =
        ['markComplete', 'markIncomplete'].includes(actionRows[1]?.action) || actionRows.length >= 3;

    const customPropertyThenOption = [
        { label: 'Text (Multiple lines)', value: 'text' },
        { label: 'Team member', value: 'team_member' },
        { label: 'Contact/Company', value: 'contact_company' },
        { label: 'Task', value: 'task' },
        { label: 'Status', value: 'status' },
        { label: 'Tag', value: 'tag' },
        { label: 'Multi-select', value: 'multi_select' },
        { label: 'File', value: 'file' },
        { label: 'URL', value: 'url' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Number', value: 'number' },
        { label: 'Text (Single line)', value: 'text' },
    ];

    const updateConditionField = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, field: value, value: '' };
                    // Automatically set operator to 'equals' (shows as 'is') when assignee is selected
                    if (value === 'assignee') {
                        newCond.operator = 'equals';
                    } else if (value === 'customerWaiting' || value === 'customerNotResponding') {
                        newCond.operator = 'moreThanMins';
                    }
                    return newCond;
                }
                return cond;
            }),
        );
    };

    const updateConditionOperator = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => (i === index ? { ...cond, operator: value, value: '' } : cond)),
        );
    };

    const updateConditionValue = (index, value) => {
        setConditions((prev) => {
            const updated = prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, value };
                    return newCond;
                }
                return cond;
            });
            return updated;
        });
    };

    const updateMessage = (index, value) => {
        const updated = [...actionRows];
        updated[index].message = value;
        setActionRows(updated);
    };

    const buildPayload = () => {
        const staticCondition = {
            field: 'board',
            operator: 'equals',
            value: boardSelect,
        };

        let allConditions = conditions;
        if (
            selectedType === 'itemAdded' ||
            selectedType === 'noReplyToCustomer' ||
            selectedType === 'noReplyFromCustomer'
        ) {
            // Check if board condition already exists
            const hasBoardCondition = conditions.some((cond) => cond.field === 'board');
            if (!hasBoardCondition) {
                allConditions = [staticCondition, ...conditions];
            }
        }

        return {
            // name: rule,
            type: selectedType,
            when: {
                gmailUserId: selectedMailUser ? selectedMailUser?.value : '',
            },
            condition: allConditions.map((c) => ({
                operand: c.field,
                operator: c.operator,
                value: c.field === 'assignee' ? [{ entityId: c.value }] : c.value,
            })),
            action: (() => {
                const baseActions = actionRows.map((a, index) => {
                    let actionName = a.action;

                    // Map form action names to API action names
                    if (a.action === 'moveToNext') {
                        actionName = 'moveToNextList';
                    } else if (a.action === 'moveToPreviousList') {
                        actionName = 'moveToPreviousList';
                    }

                    const payload = {
                        action: actionName,
                        order: index,
                    };

                    if (a.action === 'createOnList') {
                        return {
                            ...payload,
                            boardId: a.boardId,
                            entityId: a.entityId,
                        };
                    }

                    if (['assignTo', 'unassign'].includes(a.action)) {
                        return {
                            ...payload,
                            entityId: a.user,
                        };
                    }

                    if (a.action === 'assignToRoundRobin') {
                        return {
                            ...payload,
                            entityIds:
                                a.users?.map((u) => ({
                                    entityId: u.value,
                                    name: u.label,
                                })) || [],
                        };
                    }

                    // Handle SLA alert actions
                    if (a.action === 'setSlaAlertTag') {
                        return {
                            ...payload,
                            entityValue: a.entityId || [],
                        };
                    }

                    if (
                        a.action === 'sendOverdueAlert' ||
                        a.action === 'sendUpcomingAlert' ||
                        a.action === 'sendNotificationTo'
                    ) {
                        return {
                            ...payload,
                            entityId: a.entityId,
                            entityValue: a.message || '',
                        };
                    }

                    return payload;
                });

                if (selectedType === 'new') {
                    baseActions.push({ action: 'subEmailInbox', isProcessed: skipReplies });
                    baseActions.push({ action: 'emailInbox', hasReply: skipInbox });
                }
                return baseActions;
            })(),
        };
    };

    const updateBoardList = (index, value) => {
        const updated = [...actionRows];
        updated[index].entityId = value;
        setActionRows(updated);
    };

    const handleMailUserChange = (selectedOption) => {
        setSelectedMailUser(selectedOption);
        if (selectedOption && boardSelect) {
            const duplicate = checkDuplicate(boardSelect, selectedOption.value);
            setIsDuplicate(duplicate);

            if (duplicate) {
                setDuplicateMsg('Automation already exists for this gmail user and board.');
            } else {
                setDuplicateMsg('');
            }
        }
    };

    useEffect(() => {
        if (!editId) {
            setSelectedType('new');
        }
    }, []);

    // Check for duplicates when selectedType, boardSelect, selectGmailUser, or automationsData changes
    useEffect(() => {
        if (boardSelect && selectedType) {
            const duplicate = checkDuplicate(boardSelect, selectGmailUser);
            setIsDuplicate(duplicate);
            if (duplicate) {
                if (selectedType === 'new') {
                    setDuplicateMsg('Automation already exists for this board ');
                } else {
                    setDuplicateMsg(`Automation of type "${selectedType}" already exists for this board.`);
                }
            } else {
                setDuplicateMsg('');
            }
        } else {
            setIsDuplicate(false);
            setDuplicateMsg('');
        }
    }, [selectedType, boardSelect, selectGmailUser, automationsData]);

    const handleGetSyncGmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            const formattedOptions = response?.data?.map((item) => ({
                value: item.id,
                label: item.email,
            }));

            setSyncGmail(formattedOptions);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        handleGetSyncGmail();
    }, []);

    const no_reply_to_customer = [
        { label: 'more than (hours)', value: 'moreThanHrs' },
        { label: 'more than (minutes)', value: 'moreThanMins' },
        { label: 'more than (days)', value: 'moreThanDays' },
    ];

    const no_reply_then_condition = [
        { label: 'Set an SLA alert on the card', value: 'setSlaAlertTag' },
        { label: 'Send an overdue alert to', value: 'sendOverdueAlert' },
        { label: 'Send an upcoming alert to', value: 'sendUpcomingAlert' },
        { label: 'Send a notification to', value: 'sendNotificationTo' },
    ];

    const selectedIsFields = Array.isArray(conditions)
        ? conditions
            .filter((c, i) => c.operator === 'equals')
            .map((c) => c.field)
            .filter(Boolean)
        : [];

    const selectedActionTypes = actionRows.map((row) => row.action).filter(Boolean);

    const selectedFirstAction = Array.isArray(actionRows) && actionRows[0]?.action ? actionRows[0].action : null;
    const lastTwoSelected = selectedActionTypes.slice(-2);
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ scrollbarWidth: 'none' }}
        >
            <Modal.Header closeButton>
                <h2 className="text-[28px] pt-[1vw] px-[1.4vw] font-normal font-google">Create a new automation</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="flex flex-col  h-[470px] overflow-y-auto" style={{ scrollbarWidth: 'none' }}>
                    <div className="bg-white rounded-lg  p-6  w-full ">
                        <div className="flex flex-col gap-3">
                            {/* <div className="flex items-center gap-3 mb-2">
                                <span className="font-medium text-gray-700 w-[60px]">Name</span>
                                <input
                                    id="Rule"
                                    type="text"
                                    className="h-10 w-[550px] border border-gray-300 rounded px-3 text-gray-900 !focus:outline-none focus:border-blue-500"
                                    placeholder="Name"
                                    value={rule}
                                    onChange={(e) => setRule(e.target.value.trimStart())}
                                />
                            </div> */}
                            <div className="flex  gap-3">
                                <span className="font-medium text-gray-700 w-[60px]">When</span>
                                <select
                                    className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-blue-500 w-[270px]"
                                    onChange={(e) => {
                                        const type = e.target.value;
                                        setSelectedType(type);
                                        setActionRows([{ action: '', order: '', boardId: '', entityId: '' }]);
                                        setIsDuplicate(false);
                                        setDuplicateMsg('');
                                        setConditions([]);
                                        setSelectedMailUser(null);
                                        if (type === 'itemAdded') {
                                            setConditions(defaultMailConditions);
                                        } else if (type === 'noReplyToCustomer') {
                                            setConditions(defaultNoReplyToCustomerConditions);
                                        } else if (type === 'noReplyFromCustomer') {
                                            setConditions(defaultNoReplyFromCustomerConditions);
                                        } else {
                                            setConditions([
                                                {
                                                    field: conditionOptions[0].value,
                                                    operator: operatorOptions[2].value,
                                                    value: '',
                                                },
                                            ]);
                                        }

                                        // Check for duplicates after type change if board is already selected
                                        setTimeout(() => {
                                            if (boardSelect) {
                                                const duplicate = checkDuplicate(boardSelect, selectGmailUser);
                                                setIsDuplicate(duplicate);
                                                if (duplicate) {
                                                    if (type === 'new') {
                                                        setDuplicateMsg('Automation already exists for this board ');
                                                    } else {
                                                        setDuplicateMsg(
                                                            `Automation of type "${type}" already exists for this board.`,
                                                        );
                                                    }
                                                } else {
                                                    setDuplicateMsg('');
                                                }
                                            }
                                        }, 0);
                                    }}
                                    value={selectedType}
                                >
                                    <option value="new">a new mail is received</option>
                                    <option value="itemAdded">an item is added / moved to a list</option>
                                    {/* <option value="completed">an item is completed</option>
                                    <option value="reopened">an item is reopened</option>
                                    <option value="customer">a customer  property  is updated</option>
                                    <option value="as   signed">an item is assigned </option> */}
                                    <option value="noReplyToCustomer">there is no reply to a customer</option>
                                    {/* <option>the resolution time is too slow</option> */}
                                    <option value="noReplyFromCustomer">there is no reply from a customer</option>
                                </select>
                                {selectedType == 'new' && (
                                    <>
                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                            value="in the mailbox"
                                            readOnly
                                        />
                                        <Select
                                            options={syncGmail}
                                            className="border border-gray-300 rounded  w-[450px]"
                                            value={selectedMailUser}
                                            onChange={handleMailUserChange}
                                        />
                                    </>
                                )}
                            </div>

                            {/* a new mail is received  */}
                            {selectedType === 'new' && (
                                <>
                                    {Array.isArray(conditions) &&
                                        conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'if' : 'and'}
                                                </span>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white"
                                                    value={cond.field}
                                                    onChange={(e) => updateConditionField(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select a condition...
                                                    </option>
                                                    {conditionOptions
                                                        .filter(
                                                            (opt) =>
                                                                !selectedIsFields.includes(opt.value) ||
                                                                cond.field === opt.value,
                                                        )
                                                        .map((opt, i) => (
                                                            <option key={i} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                    value={cond.operator}
                                                    onChange={(e) => updateConditionOperator(index, e.target.value)}
                                                >
                                                    {operatorOptions.map((op, i) => (
                                                        <option key={i} value={op.value}>
                                                            {op.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 w-[450px] bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                />

                                                {conditions.length > 1 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 fonst-bold text-xl"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>
                                    <div>
                                        {actionRows.map((row, i) => (
                                            <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {i == 0 ? 'then' : ' and'}
                                                </span>

                                                {i == 0 ? (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white"
                                                            disabled
                                                        >
                                                            <option>move it to the board</option>
                                                        </select>
                                                        <select
                                                            className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                            value={row.boardId || ''}
                                                            onChange={(e) => {
                                                                updateAction(i, e.target.value);
                                                                handleBoardChange(e.target.value);
                                                            }}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a board...
                                                            </option>
                                                            {boardName?.map((item) => (
                                                                <option key={item.value} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <select
                                                            className="border border-gray-300 rounded px-3 py-2 w-[450px] bg-white"
                                                            value={row.entityId || ''}
                                                            onChange={(e) => updateBoardList(i, e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a list...
                                                            </option>
                                                            {selectedBoardColumn &&
                                                                selectedBoardColumn?.map((item, idx) => (
                                                                    <option key={idx} value={item.id}>
                                                                        {item.coloum}
                                                                    </option>
                                                                ))}
                                                        </select>
                                                    </>
                                                ) : (
                                                    <select
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                        value={row.action}
                                                        onChange={(e) => updateAction(i, e.target.value)}
                                                    >
                                                        <option value="">Select Action</option>

                                                        {(i === 1
                                                            ? availableActions.filter((item) => {
                                                                if (!selectedFirstAction) return true;

                                                                const firstGroup = [
                                                                    'assignTo',
                                                                    'assignToRoundRobin',
                                                                    'unassign',
                                                                ];
                                                                const secondGroup = ['markComplete'];

                                                                // restrict based on group
                                                                if (firstGroup.includes(selectedFirstAction)) {
                                                                    return item.value !== selectedFirstAction;
                                                                }

                                                                if (secondGroup.includes(selectedFirstAction)) {
                                                                    return !secondGroup.includes(item.value);
                                                                }

                                                                return true;
                                                            })
                                                            : availableActions
                                                        )
                                                            // Exclude last 2 selected actions (excluding current row's selected one)
                                                            .filter((action) => {
                                                                return (
                                                                    !lastTwoSelected.includes(action.value) ||
                                                                    row.action === action.value
                                                                );
                                                            })
                                                            .map((item, idx) => (
                                                                <option key={idx} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                    </select>
                                                )}

                                                {showUserSelectFor.includes(row.action) &&
                                                    (row.action === 'assignToRoundRobin' ? (
                                                        <Select
                                                            isMulti
                                                            options={options}
                                                            className="border border-gray-300  rounded w-[500px] py-[1px]"
                                                            placeholder="Select users"
                                                            value={row.users || []}
                                                            onChange={(selected) => updateUser(i, selected, true)} // `true` means it's multi
                                                        />
                                                    ) : (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(i, e.target.value)}
                                                        >
                                                            <option value="">Select user</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ))}

                                                {i > 0 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(i, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {!shouldHideAddButton && (
                                            <a
                                                onClick={addActionRow}
                                                className="text-blue-500 font-bold px-4 py-2  text-decoration-none"
                                                style={{ minWidth: '120px' }}
                                                type="button"
                                            >
                                                + Add action
                                            </a>
                                        )}
                                    </div>
                                </>
                            )}

                            {/* Display duplicate error message */}
                            {duplicateMsg && (
                                <div className="flex items-center gap-3 mt-2">
                                    <span className="font-medium text-gray-700 w-[60px]"></span>
                                    <div className="text-red-500 text-sm bg-red-50 border border-red-200 rounded px-3 py-2 w-90">
                                        ⚠️ {duplicateMsg}
                                    </div>
                                </div>
                            )}

                            {selectedType === 'new' && (
                                <div className="mt-6 border-t pt-4">
                                    <div className="font-bold text-lg mb-2">Advanced options</div>
                                    <div className="flex flex-col gap-3">
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={!skipInbox}
                                                onChange={(e) => setSkipInbox(!e.target.checked)}
                                            />
                                            New emails should skip the inbox
                                        </label>
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={skipReplies}
                                                onChange={(e) => setSkipReplies(e.target.checked)}
                                            />
                                            Replies to existing conversations already on the board should skip the inbox
                                        </label>
                                        {/* <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={runOnExisting}
                                                onChange={e => setRunOnExisting(e.target.checked)}
                                            />
                                            <span>Run this automation on existing emails in the Inbox, going back</span>
                                            <select
                                                className="ml-2 border rounded px-2 py-1"
                                                value={existingDays}
                                                onChange={e => setExistingDays(e.target.value)}
                                                disabled={!runOnExisting}
                                            >
                                                <option value="1">1 day</option>
                                                <option value="3">3 days</option>
                                                <option value="7">7 days</option>
                                                <option value="30">30 days</option>
                                            </select>
                                        </label> */}
                                    </div>
                                </div>
                            )}
                            {/* itemAdded */}
                            {selectedType == 'itemAdded' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2  bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {Array.isArray(conditions) &&
                                        conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">and</span>
                                                <select
                                                    className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white"
                                                    value={cond.field}
                                                    onChange={(e) => updateConditionField(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        choose an option...
                                                    </option>
                                                    {completedConditionOptions
                                                        .filter(
                                                            (opt) =>
                                                                !selectedIsFields.includes(opt.value) ||
                                                                cond.field === opt.value,
                                                        )
                                                        .map((opt, i) => (
                                                            <option key={i} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                    value={cond.operator}
                                                    onChange={(e) => updateConditionOperator(index, e.target.value)}
                                                >
                                                    {operatorOptions.map((op, i) => (
                                                        <option key={i} value={op.value}>
                                                            {op.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {cond?.field === 'assignee' && (
                                                    <select
                                                        className="border border-gray-300  w-[450px] rounded px-3 py-2  bg-white"
                                                        value={cond.value || ''}
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    >
                                                        <option value="" disabled>
                                                            Choose user...
                                                        </option>
                                                        {userData.map((item, i) => (
                                                            <option key={i} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                {(cond?.field === 'title' ||
                                                    cond?.field === 'sender' ||
                                                    cond?.field === 'recipient') && (
                                                        <input
                                                            type="text"
                                                            className="border border-gray-300 w-[450px] rounded px-3 py-2 bg-white"
                                                            value={cond.value}
                                                            placeholder="specify..."
                                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                                        />
                                                    )}
                                                {cond.field === 'listName' && (
                                                    <select
                                                        className="border border-gray-300 w-[450px] rounded px-3 py-2 bg-white"
                                                        value={cond.value || ''}
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    >
                                                        <option value="" disabled>
                                                            Choose a list...
                                                        </option>
                                                        {selectedBoardColumn.map((item, i) => (
                                                            <option key={i} value={item.id}>
                                                                {item.coloum}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}

                                                {conditions.length > 1 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                {/* Action dropdown */}
                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2  w-[270px] bg-white"
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {conditionThenOption.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* User select for specific actions */}

                                                {showUserSelectFor.includes(row.action) &&
                                                    (row.action === 'assignToRoundRobin' ? (
                                                        <Select
                                                            isMulti
                                                            options={options}
                                                            className="border border-gray-300  rounded w-[500px] py-[1px]"
                                                            placeholder="Select users"
                                                            value={row.users || []}
                                                            onChange={(selected) => updateUser(index, selected, true)} // `true` means it's multi
                                                        />
                                                    ) : (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(index, e.target.value)}
                                                        >
                                                            <option value="">Select user</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ))}

                                                {row.action === 'createOnList' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 rounded w-[200px]  px-3 py-2  bg-white"
                                                            value={row.boardId || ''}
                                                            onChange={(e) => {
                                                                updateAction(index, e.target.value),
                                                                    getSELECTED_BOARD(e.target.value);
                                                            }}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a board...
                                                            </option>
                                                            {boardName.map((item) => (
                                                                <option key={item.value} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <select
                                                            className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                            value={row.entityId || ''}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a list...
                                                            </option>
                                                            {selectedBoardColumn.map((item, i) => (
                                                                <option key={i} value={item.id}>
                                                                    {item.coloum}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </>
                                                )}

                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Add action button */}

                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}

                            {/* no reply to customer */}
                            {selectedType === 'noReplyToCustomer' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300 rounded px-3 py-2   w-[270px] bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 rounded  w-[200px] px-3 py-2 bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2 bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {conditions.map((cond, index) => (
                                        <div key={index} className="flex items-center gap-3 mb-1">
                                            <span className="font-medium text-gray-700 w-[60px]">and</span>

                                            <select
                                                className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white"
                                                value={cond.field}
                                                onChange={(e) => updateConditionField(index, e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    choose an option...
                                                </option>

                                                {(index === 0
                                                    ? [
                                                        {
                                                            label: 'the customer has been waiting',
                                                            value: 'customerWaiting',
                                                        },
                                                    ]
                                                    : ConditionOptions
                                                )
                                                    .filter(
                                                        (opt) =>
                                                            !selectedIsFields.includes(opt.value) ||
                                                            cond.field === opt.value,
                                                    )
                                                    .map((opt, i) => (
                                                        <option key={i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded  w-[200px] px-3 py-2 bg-white"
                                                value={cond.operator}
                                                onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            >
                                                {/* {operatorOptions.map((op, i) => (
                                                    <option key={i} value={op}>{op}</option>
                                                ))} */}
                                                {(cond.field === 'assignee'
                                                    ? [{ label: 'is', value: 'equals' }] // Only allow 'is'
                                                    : index === 0
                                                        ? no_reply_to_customer
                                                        : operatorOptions
                                                ).map((opt, i) => (

                                                    <option key={i} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {index === 0 && (
                                                <div className="flex flex-col">
                                                    <input
                                                        type="number"
                                                        className={`border rounded w-[450px] px-3 py-2 bg-white ${cond.operator === 'moreThanMins' &&
                                                            parseInt(cond.value) < 2 &&
                                                            cond.value !== ''
                                                            ? 'border-red-500'
                                                            : 'border-gray-300'
                                                            }`}
                                                        value={cond.value}
                                                        min="2"
                                                        placeholder="specify...."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                    {cond.operator === 'moreThanMins' &&
                                                        parseInt(cond.value) < 2 &&
                                                        cond.value !== '' && (
                                                            <span className="text-xs mt-1 text-red-500">
                                                                Error: Minutes must be at least 15 for SLA alerts
                                                            </span>
                                                        )}
                                                </div>
                                            )}

                                            {cond?.field === 'assignee' && (
                                                <select
                                                    className="border border-gray-300 rounded px-3  w-[450px] py-2  bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose user...
                                                    </option>
                                                    {userData.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            {(cond?.field === 'title' ||
                                                cond?.field === 'sender' ||
                                                cond?.field === 'recipient') && (
                                                    <input
                                                        type="text"
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                        value={cond.value}
                                                        placeholder="specify..."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                )}
                                            {cond.field === 'listName' && (
                                                <select
                                                    className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                    value={cond.value || ''}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose a list...
                                                    </option>
                                                    {selectedBoardColumn.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.coloum}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex  gap-3 mb-2 ">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                {/* Action dropdown */}
                                                <select
                                                    className="border h-[fit-content] border-gray-300 rounded px-3  w-[270px] py-2 bg-white "
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {no_reply_then_condition.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {row.action === 'setSlaAlertTag' && (
                                                    <>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={formattedOptions}
                                                            value={formattedOptions.filter((item) =>
                                                                (row.entityId || []).includes(item.value),
                                                            )}
                                                            onChange={(selectedOptions) =>
                                                                updateBoardList(
                                                                    index,
                                                                    selectedOptions.map((opt) => opt.value),
                                                                )
                                                            }
                                                            placeholder="Choose SLA alerts..."
                                                            className="w-[500px]  border border-gray-300 rounded "
                                                            styles={customStyles}
                                                            components={{
                                                                MultiValue,
                                                                MultiValueRemove: () => null,
                                                                Option,
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                {row.action === 'sendOverdueAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] w-[200px] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300  w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm  text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="🔥Overdue - Customer is waiting for a reply."
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendUpcomingAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[200px]  h-[fit-content] rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 h-[fit-content] w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="⚡Upcoming soon - Don’t forget"
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendNotificationTo' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] rounded w-[200px] px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="Issue escalated to you"
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Add action button */}

                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}

                            {selectedType === 'noReplyFromCustomer' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300  w-[270px] rounded px-3 py-2  bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 w-[200px] rounded px-3 py-2 bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2 bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {conditions.map((cond, index) => (
                                        <div key={index} className="flex items-center gap-3 mb-1">
                                            <span className="font-medium text-gray-700 w-[60px]">and</span>

                                            <select
                                                className="border border-gray-300  w-[270px] rounded px-3 py-2 bg-white"
                                                value={cond.field}
                                                onChange={(e) => updateConditionField(index, e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    choose an option...
                                                </option>

                                                {(index === 0
                                                    ? [
                                                        {
                                                            label: 'the team has been waiting',
                                                            value: 'customerNotResponding',
                                                        },
                                                    ]
                                                    : ConditionOptions
                                                )
                                                    .filter(
                                                        (opt) =>
                                                            !selectedIsFields.includes(opt.value) ||
                                                            cond.field === opt.value,
                                                    )
                                                    .map((opt, i) => (
                                                        <option key={i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3  w-[200px] py-2 bg-white"
                                                value={cond.operator}
                                                onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            >
                                                {/* {operatorOptions.map((op, i) => (
                                                    <option key={i} value={op}>{op}</option>
                                                ))} */}

                                                {(cond.field === 'assignee'
                                                    ? [{ label: 'is', value: 'equals' }] // Only allow 'is'
                                                    : index === 0
                                                        ? no_reply_to_customer
                                                        : operatorOptions
                                                ).map((opt, i) => (
                                                    <option key={i} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {index === 0 && (
                                                <div className="flex flex-col">
                                                    <input
                                                        type="number"
                                                        className={`border rounded px-3 py-2 w-[450px] bg-white ${cond.operator === 'moreThanMins' &&
                                                            parseInt(cond.value) < 2 &&
                                                            cond.value !== ''
                                                            ? 'border-red-500'
                                                            : 'border-gray-300'
                                                            }`}
                                                        value={cond.value}
                                                        min="2"
                                                        placeholder="specify...."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                    {cond.operator === 'moreThanMins' &&
                                                        parseInt(cond.value) < 2 &&
                                                        cond.value !== '' && (
                                                            <span className="text-xs mt-1 text-red-500">
                                                                Error: Minutes must be at least 15 for SLA alerts
                                                            </span>
                                                        )}
                                                </div>
                                            )}
                                            {cond?.field === 'assignee' && (
                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2  w-[450px]  bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose user...
                                                    </option>
                                                    {userData.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            {(cond?.field === 'title' ||
                                                cond?.field === 'sender' ||
                                                cond?.field === 'recipient') && (
                                                    <input
                                                        type="text"
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                        value={cond.value}
                                                        placeholder="specify..."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                )}
                                            {cond.field === 'listName' && (
                                                <select
                                                    className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                    value={cond.value || ''}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose a list...
                                                    </option>
                                                    {selectedBoardColumn.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.coloum}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                {/* Action dropdown */}
                                                <select
                                                    className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white "
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {no_reply_then_condition.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {row.action === 'setSlaAlertTag' && (
                                                    <>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={formattedOptions}
                                                            value={formattedOptions.filter((item) =>
                                                                (row.entityId || []).includes(item.value),
                                                            )}
                                                            onChange={(selectedOptions) =>
                                                                updateBoardList(
                                                                    index,
                                                                    selectedOptions.map((opt) => opt.value),
                                                                )
                                                            }
                                                            placeholder="Choose SLA alerts..."
                                                            className="w-[500px]"
                                                            styles={customStyles}
                                                            components={{
                                                                MultiValue,
                                                                MultiValueRemove: () => null, // 🔹 disables remove icon
                                                                Option,
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                {row.action === 'sendOverdueAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] w-[200px] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 rounded px-3 py-2 bg-white w-[450px]">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="🔥Overdue - Customer is waiting for a reply."
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendUpcomingAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[200px]  h-[fit-content] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300  h-[fit-content] w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="⚡Upcoming soon - Don’t forget"
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendNotificationTo' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300  h-[fit-content] rounded w-[200px] px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 rounded px-3 w-[450px] py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="Issue escalated to you"
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {/* Add action button */}

                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}
                            {(selectedType === 'completed' ||
                                selectedType === 'reopened' ||
                                selectedType === 'customer' ||
                                selectedType === 'assigned') && (
                                    <>
                                        {conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'if' : 'and'}
                                                </span>

                                                <select className="border border-gray-300 rounded px-3 py-2  bg-white">
                                                    <option value="" disabled>
                                                        choose an option...
                                                    </option>
                                                    {(index === 0
                                                        ? [{ label: 'the board', value: 'board' }]
                                                        : selectedType === 'completed' || selectedType === 'assigned'
                                                            ? completedConditionOptions
                                                            : customPropertyThenOption
                                                    ).map((opt, i) => (
                                                        <option key={opt.value || i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                // value={cond.operator}
                                                // onChange={(e) => updateConditionOperator(index, e.target.value)}
                                                >
                                                    {index === 0
                                                        ? ['is'].map((op, i) => (
                                                            <option key={i} value={op}>
                                                                {op}
                                                            </option>
                                                        ))
                                                        : operatorOptions.map((op, i) => (
                                                            <option key={i} value={op}>
                                                                {op}
                                                            </option>
                                                        ))}
                                                </select>

                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                />

                                                {conditions.length > 0 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 font-bold text-xl px-2"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <div>
                                            <a
                                                onClick={addCondition}
                                                className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                            >
                                                + Add condition
                                            </a>
                                        </div>

                                        {/* Actions */}

                                        <div className="flex items-center gap-3 mb-1 mt-4">
                                            <span className="font-medium text-gray-700 w-[60px]">Then</span>

                                            <select className="border border-gray-300 rounded px-3 py-2 bg-white">
                                                {conditionThenOption.map((item, i) => (
                                                    <option key={i} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2  bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName?.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2  bg-white"
                                                value={boardColumnSelect}
                                                onChange={(e) => setBoardColumnSelect(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a list...
                                                </option>
                                                {selectedBoardColumn?.map((item, i) => (
                                                    <option key={i} value={item.id}>
                                                        {item.coloum}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            {actionRows.map((row, i) => (
                                                <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                                    <span className="font-medium text-gray-700 w-[60px]">and</span>
                                                    {/* Action dropdown */}
                                                    <select
                                                        className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                        value={row.action}
                                                        onChange={(e) => updateAction(i, e.target.value)}
                                                    >
                                                        <option value="">Select Action</option>
                                                        {(i === 0 ? availableActions : availableActions.slice(3)).map(
                                                            (item, idx) => (
                                                                <option key={idx} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ),
                                                        )}
                                                    </select>
                                                    {/* Conditionally show User select */}
                                                    {showUserSelectFor.includes(row.action) && (
                                                        <select
                                                            className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(i, e.target.value)}
                                                        >
                                                            <option value="">Select user</option>
                                                            {userData.map((user, j) => (
                                                                <option key={j} value={user.id}>
                                                                    {user.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )}
                                                    {/* Remove row button */}
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(i, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="ml-2  w-8 h-8 flex items-center justify-center text-lg font-bold"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                            {!shouldHideAddButton && (
                                                <a
                                                    onClick={addActionRow}
                                                    className="text-blue-500 font-bold px-4 py-2  text-decoration-none"
                                                    style={{ minWidth: '120px' }}
                                                    type="button"
                                                >
                                                    + Add action
                                                </a>
                                            )}
                                        </div>
                                    </>
                                )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="flex justify-end w-full">
                    <button
                        className=" text-gray-800 border font-google border-solid border-[#bdbdbd]  font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2"
                        onClick={() => setStep(1)}
                    >
                        Cancel
                    </button>
                    <button
                        disabled={isDuplicate}
                        className={`font-google text-white font-bold py-2 px-4 font-normal rounded focus:outline-none focus:shadow-outline
                            ${isDuplicate
                                ? 'bg-gray-500 cursor-not-allowed'
                                : 'bg-blue-500 hover:bg-blue-700 cursor-pointer'
                            }`}
                        onClick={() => {
                            if (!boardSelect) {
                                toast.error('Please Select Board');
                                return;
                            } else if (selectedType === 'new' && !selectedMailUser) {
                                toast.error('Please Select Gmail User');
                                return;
                            } else if (isDuplicate) {
                                if (selectedType === 'new') {
                                    toast.error('Automation already exists for this board ');
                                } else {
                                    toast.error(`Automation of type "${selectedType}" already exists for this board.`);
                                }
                                return;
                            } else {
                                // Validate minutes for noReplyToCustomer and noReplyFromCustomer
                                const hasInvalidMinutes = conditions.some((cond) => {
                                    if (cond.operator === 'moreThanMins' && cond.field === 'customerWaiting') {
                                        const minutes = parseInt(cond.value);
                                        return isNaN(minutes) || minutes < 2;
                                    }
                                    if (cond.operator === 'moreThanMins' && cond.field === 'teamWaiting') {
                                        const minutes = parseInt(cond.value);
                                        return isNaN(minutes) || minutes < 2;
                                    }
                                    return false;
                                });

                                if (hasInvalidMinutes) {
                                    // Don't show toast, let the inline error messages handle it
                                    return;
                                }

                                handleCreate();
                            }
                        }}
                    >
                        {editId ? 'Update' : 'Create'}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default Automation;
